// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { profileHrColor } from "../../utils/commonJssConstants";

export const ProfilePrivacyStyles = (config: DesignSystem) => ({
    profilePrivacyContainer: {
        margin: "25px 20px",

        "& .cwt-title": {
            "font-size": "15px",
            "font-weight": "600",
            margin: "0 0 2px 0",
            color: neutralForegroundRest
        },

        "& .cwt-private-switch": {
            display: "flex",
            "align-items": "center",
            color: neutralForegroundRest, // On/Off button color added

            "& .cwt-switch-label": {
                margin: "0 0 2px 0"
            },

            "& .cwt-switch": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "27px"
            },

            "& .cwt-on-label": {
                margin: "0 8px",
                "font-size": "14px"
            }
        },

        "& .cwt-description": {
            "margin-top": "11px",
            "font-size": "13px",
            color: neutralForegroundRest
        },

        "& .cwt-h-seperator": {
            height: "1px",
            margin: "20px -20px 20px",
            background: profileHrColor,
            border: "none"
        }
    },

    profileDataContainer: {
        "& .cwt-description": {
            "font-size": "13px",
            "line-height": "20px",
            color: neutralForegroundRest
        },

        "& button.cwt-fast-button": {
            margin: "8px 0"
        }
    }
});